import { FrameShape, ShopPageGlassesColor } from 'constants/dataTypes';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';

import { useVTOStore } from 'zus/vtoStore';
import ProductCardwLensColour from './ProductCardwLensColour';

interface ProductCardwVTOProps {
  data: {
    categorySlug: string;
    customTitle?: string;
    colorSlug?: string;
    armColorSlug?: string;
    href: string;
    title: string;
    price: any;
    isPriority: boolean;
    regularPrice?: number;
    colors?: ShopPageGlassesColor[];
    shape?: FrameShape;
    vtoEnabled?: boolean
  };
  width: number;
  categoryLensTypes?: any;
  onClickProduct?: () => void;
  onVTOToggle: () => void;
  initialLensColor?: string;
}

function ProductCardwVTO({ data, width, onClickProduct, categoryLensTypes, onVTOToggle, initialLensColor }: ProductCardwVTOProps) {
 

  const router = useRouter();
  
  const setSelectedColors = useVTOStore((state) => state.setSelectedColors);
  const updateVisibility = useVTOStore((state) => state.updateVisibility);
  const setCustomTitle = useVTOStore((state) => state.setCustomTitle);
  const setPrice = useVTOStore((state) => state.setPrice);

  const setCategory = useVTOStore((state) => state.setCategory);

  const toggleVTOModal = (lensColour:any, armColorSlug:string, shape:FrameShape, price?: number, regularPrice?: number) => {

    if(!data.colorSlug) {
      return;
    }
    const isSunglassess = data.categorySlug.includes('sunglasses') || data.categorySlug.includes('sun-glasses');

    setCategory(data.categorySlug);
    setSelectedColors(data.colorSlug, data.armColorSlug || data.colorSlug, isSunglassess ? lensColour: 'clear', shape);

    setPrice(price || data.price, regularPrice || data.regularPrice || data.price);
    if(data.customTitle) {
      setCustomTitle(data.customTitle);
    }

    updateVisibility(true);
    onVTOToggle();
  };

   /*
useMemo(() => {
  if(data.colors) {
    const colorv = data.colors.map((color: { slug: any; name: any; description: any; }) => {
      
      return {
        slug: color.slug,
        name: color.name,
        color: color.description
      }
    }
    );
    setColors(router.locale, colorv);
  }
}, [data.colors, router.locale, setColors]);*/




  return (
    <>
    {/* {!(router.asPath.indexOf('sunglasses') > -1) && 
      <ProductCard
          vtoEnabled={true}
          toggleVTO={(color:any) => {
            toggleVTOModal('clear');
          }}
          onClickPoroduct={onClickProduct}
          width={width}
          data={{
            images: [],
            title: data.title,
            price: data.price,
            regularPrice: data.regularPrice,
            href: data.href,
            prio: data.isPriority
          }}
        />
      } */}
      {
        <ProductCardwLensColour
          vtoEnabled={data?.vtoEnabled == false ? data.vtoEnabled : true}
          toggleVTO={(color:any, armColorSlug:string, shape:FrameShape, price?: number, regularPrice?: number) => {
            toggleVTOModal(color, armColorSlug, shape, price, regularPrice);
          }}
          onClickPoroduct={onClickProduct}
          categoryLensTypes={categoryLensTypes}
          width={width}
          initialLensColor={initialLensColor}
          data={{
            images: [],
            title: data.title,
            price: data.price,
            regularPrice: data.regularPrice,
            categorySlug: data.categorySlug,
            href: data.href,
            prio: data.isPriority,
            shape: data.shape,
            colorSlug: data.colorSlug,
            armColorSlug: data.armColorSlug
          }}
        />
      }
    </>
  );
}


export default React.memo(ProductCardwVTO);
